var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedCurrency && _vm.selectedCurrency.name
    ? _c("div", { staticClass: "currency-select" }, [
        _c(
          "form",
          { staticClass: "styled-dropdown", attrs: { id: "currency-form" } },
          [
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.selectedCurrency.symbol) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.selectedCurrency.name)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "caret" }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-fw fa-chevron-down float-right",
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-fw fa-chevron-up float-right",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "dropdown-menu" },
                _vm._l(_vm.currencies, function (currency) {
                  return _c(
                    "li",
                    {
                      key: currency.name,
                      staticClass: "clearfix",
                      attrs: { "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          return _vm.selectCurrency(currency)
                        },
                      },
                    },
                    [
                      _c("label", [
                        _c("span", { staticClass: "currency-icon" }, [
                          _vm._v(_vm._s(currency.symbol)),
                        ]),
                        _vm._v(" " + _vm._s(currency.name)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }